// O resumo de uma mensagem para a LISTA de conversas: o que aparece embaixo do
// nome ("Norma: vou revisar", "Mensagem de áudio"). Mesmo formato que o backend
// manda em `last_message` (`InternalChatMessage#resumo_para_lista`) — quando a
// mensagem chega pelo cabo, a lista se atualiza sem esperar recarregar.

const TIPOS = [
  ['is_audio', 'audio'],
  ['is_image', 'image'],
  ['is_video', 'video'],
];

export const tipoDoAnexo = (anexos = []) => {
  const [primeiro] = anexos || [];
  if (!primeiro) return null;
  const achado = TIPOS.find(([campo]) => primeiro[campo]);
  return achado ? achado[1] : 'file';
};

export const resumoDaMensagem = mensagem => ({
  id: mensagem.id,
  content: mensagem.content || '',
  sender_id: mensagem.sender?.id ?? mensagem.sender_id ?? null,
  sender_name: mensagem.sender?.name ?? mensagem.sender_name ?? null,
  created_at: mensagem.created_at,
  attachment_kind: tipoDoAnexo(mensagem.attachments),
});
